export type VisaoEscopoPadrao = "EQUIPAMENTOS" | "CLASSE" | "OUTROS";

export type PeriodicidadeEscopoPadrao = "INTERMEDIARIA" | "OVERHAUL" | "UNICA";

export type SituacaoEscopoPadrao = "ATIVO" | "INATIVO";

export interface CustoPorPeriodicidade {
  periodicidade: PeriodicidadeEscopoPadrao;
  horas: number | null;
  valorServicos: number | null;
  moedaServicosId: string | null;
  valorMateriais: number | null;
  moedaMateriaisId: string | null;
}

export interface VersaoEscopoPadrao {
  versao: string;
  vigente: boolean;
}

export interface MoedaDoCusto {
  id: string;
  codigo: string;
}

export interface CustoEscopoPadrao {
  periodicidade: PeriodicidadeEscopoPadrao;
  horas: number | null;
  valorServicos: number | null;
  moedaServicos: MoedaDoCusto | null;
  valorMateriais: number | null;
  moedaMateriais: MoedaDoCusto | null;
}

export interface EscopoPadraoLinha {
  id: string;
  visao: VisaoEscopoPadrao;
  tipoObra: { id: string; codigo: string; nome: string };
  grupo: { id: string; nome: string } | null;
  subgrupo: { id: string; nome: string } | null;
  embarcacao: { id: string; nome: string } | null;
  escopo: string;
  equipamento: {
    id: string;
    tag: string;
    fabricante: string | null;
    modelo: string | null;
  } | null;
  custos: CustoEscopoPadrao[];
  situacao: SituacaoEscopoPadrao;
  dataInativacao: string | null;
  ultimaAlteracao: { em: string; por: string };
  uso: { escopos: number; obras: number };
}

export interface ListaEscoposPadrao {
  versao: string | null;
  items: EscopoPadraoLinha[];
  total: number;
}

export const ESCOPOS_PADRAO_SORT_FIELDS = [
  "tipoObra",
  "grupo",
  "subgrupo",
  "embarcacao",
  "escopo",
  "equipamento",
  "situacao",
  "ultimaAlteracao",
] as const;

export type OrdenarEscoposPadraoPor = (typeof ESCOPOS_PADRAO_SORT_FIELDS)[number];

export interface ListarEscoposPadraoParams {
  versao: string;
  visao: VisaoEscopoPadrao;
  tipoObraId?: string;
  grupoEscopoMacroId?: string;
  embarcacaoId?: string;
  incluirInativos?: boolean;
  page?: number;
  pageSize?: number;
  sort?: { field: OrdenarEscoposPadraoPor; direction: "asc" | "desc" };
}

export interface EquipamentoOpcao {
  id: string;
  tag: string;
  fabricante: string | null;
  modelo: string | null;
  tagJaCadastrada: boolean;
}

export interface ListarEquipamentosParams {
  embarcacaoId: string;
  grupoEscopoMacroId: string;
}

export interface NovoEscopoPadraoBody {
  tipoObraId: string;
  embarcacaoId: string;
  equipamentoSfiId?: string | null;
  grupoEscopoMacroId?: string | null;
  subgrupoEscopoMacroId?: string | null;
  escopo?: string | null;
  custos: CustoPorPeriodicidade[];
}

export interface EscopoPadraoGravado {
  id: string;
  versao: string;
  visao: VisaoEscopoPadrao;
}

export interface EditarEscopoPadraoBody {
  custos: CustoPorPeriodicidade[];
}

export interface SituacaoEscopoPadraoBody {
  situacao: SituacaoEscopoPadrao;
}

export interface ProximaVersao {
  origem: string;
  destino: string;
  escoposACopiar: number;
}

export interface NovaVersaoBody {
  versaoOrigem: string;
  percentualServicos?: number;
  percentualMateriais?: number;
}

export interface VersaoCriada {
  versao: string;
  escoposCopiados: number;
}
